import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PatchFinishRequestPreview,
	PatchFinishRequestPreviewResponse,
} from 'domain/usecases/private/refund/request-preview';

export class RemotePatchFinishRequestPreview implements PatchFinishRequestPreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PatchFinishRequestPreviewResponse>,
	) {}

	async patch(): Promise<PatchFinishRequestPreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
